import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';

import Alert from '../../../dialogs/Alert';

class Licences extends React.Component {

    state = {
        licencia: {},
        showwarning: undefined,
        secondwarning: false
    }

    static getDerivedStateFromProps(props, state) {
        const { licencia } = props;
        if (licencia !== state.licencia) {
            state.licencia = licencia;
            return state;
        }
        return null;
    }

    handleChecked = (event) => {
        const { licencia } = this.state;
        if(event.target.checked || (licencia.id !== 151 && licencia.id !== 157)) {
            licencia.activo = event.target.checked;
            this.setState({ licencia: licencia });
            this.props.onChange(licencia.id, licencia);
        } else if(licencia.id === 151) {
            this.setState({ showwarning: 'alert_dialog_corfirm_advance_message' });
        } else if(licencia.id === 157) {
            this.setState({ showwarning: 'alert_dialog_corfirm_sts_message' });
        }
       
    }

    onCancel = (event) => {
        this.setState({ showwarning: undefined, secondwarning: false });
    }

    onConfirm = () => {
        this.setState({ showwarning: undefined, secondwarning: true });
    }

    onSet = () => {
        const { licencia } = this.state;
        licencia.activo = false;
        this.setState({ licencia: licencia, secondwarning: false });
        this.props.onChange(licencia.id, licencia);
    }

    handleChange = (event) => {
        const { licencia } = this.state;
        licencia.quota = event.target.value;
        this.setState({ licencia: licencia  });
        this.props.onChange(licencia.id, licencia);
    }

    render() {
        const { intl } = this.props;
        const { licencia, showwarning, secondwarning } = this.state;
        return (
            <div className="flex_full_column boxBorder center padding_borders">
                <span className="barlowsemicondensed_semibold_link margin_bottom_5">
                    {
                        licencia.nombre
                    }
                </span>
                <span className="barlow_regular_subtitle c_slate margin_bottom_5">
                    {
                        licencia.descripcion
                    }
                </span>
                <div className="flex_auto_row align_center width100 margin_bottom_5">
                    <Switch
                        id={licencia.id.toString() + "_active"}
                        disabled={licencia.forced}
                        onChange={this.handleChecked}
                        checked={licencia.activo}
                        value="saved"
                        color="primary"
                    />
                    <div className="flex_auto_row barlow_regular_subtitle ">
                        <FormattedMessage id="form_field_name_active" />
                    </div>
                </div>
                {licencia.quotable &&
                    <TextField
                        id={licencia.id.toString() + "_quota"}
                        label={intl.formatMessage({ id: 'form_field_name_amount' }) + ": " + (licencia.quotaUsed ? licencia.quotaUsed : '') }
                        fullWidth
                        type="number"
                        className="margin_bottom_12 padding_top_24 barlow_regular_subtitle"
                        value={licencia.quota}
                        InputLabelProps={{ shrink: true }}
                        onChange={this.handleChange}
                    />
                }
                {showwarning &&
                    <Alert
                        title="alert_dialog_corfirm_title"
                        text={showwarning}
                        open={true}
                        onCancel={this.onCancel}
                        onConfirm={this.onConfirm}
                        />
                }
                {secondwarning &&
                    <Alert
                        title="alert_dialog_corfirm_title"
                        text={'alert_dialog_corfirm_sure'}
                        open={true}
                        onCancel={this.onCancel}
                        onConfirm={this.onSet}
                        />
                }
            </div>
        )
    }
}

export default Licences;


// WEBPACK FOOTER //
// ./src/components/complex/manage/customer/License.js